import { IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface WaterPressureModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const WaterPressureModal: React.FC<WaterPressureModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.waterPressureHeading)}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.clampPressureOverviewDescriptionOne)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.clampPressureOverviewDescriptionTwo)}</DqText>
      </IonRow>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.insightsHeading)}</DqText>
      </IonRow>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.waterPressureInsightDescriptionOne)}</DqText>
        </li>
        <ul>
          <li>
            <DqText variant="body">{formatMessage(JobMessages.waterPressureInsightDescriptionOneBullet)}</DqText>
          </li>
        </ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.waterPressureInsightDescriptionTwo)}</DqText>
        </li>
      </ul>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.issuesHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.waterPressureIssuesDescription)}</DqText>
      </IonRow>
    </AppModal>
  );
};

export default WaterPressureModal;
